import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';
import { WithAvailabilityBlockId } from '@mews-commander/types';
import { usePickUpReservation } from '../../utils/usePickUpReservation';

type PickUpReservationButtonProps = WithAvailabilityBlockId;

export const PickUpReservationButton: React.FC<PickUpReservationButtonProps> = ({ availabilityBlockId }) => {
    const pickUp = usePickUpReservation(availabilityBlockId);

    if (!pickUp) {
        return null;
    }

    return (
        <Button variant="tertiary" onClick={pickUp} data-pickup-reservation type="submit">
            <LocalizedText textKey={TextKey.PickUp} />
        </Button>
    );
};
